// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3c5yM","logo":"styles_logo__3a62_","container":"styles_container__29y-B"};